"use client";
import React, { useState } from "react";
import { MobileHeader } from "../MobileHeader";
import { TabBar } from "../TabBar";
import { Link } from "react-router-dom";
import ToastNotification from "../ToastNotification";

const TopUpDashboard: React.FC = () => {
  const [toast, setToast] = useState<{type: 'success' | 'info' | 'warning' | 'error', message: string, description?: string} | null>(null);
  
  return (
    <main className="pb-96 mx-auto w-full max-w-[480px]">
      <div className="overflow-hidden w-full bg-white">
        <MobileHeader />
        <div className="relative py-9 w-full">
          <div className="z-0 w-full text-2xl font-semibold leading-none text-gray-900">
            <div className="px-4 w-full">
              <div className="w-full">
                <div className="w-full">
                  <div className="w-full">Top Up</div>
                </div>
              </div>
            </div>
          </div>
          <div className="z-0 px-4 mt-8 w-full">
            {/* Current Plan */}
            <div className="overflow-hidden w-full bg-white rounded-xl border border-solid shadow-sm border-[#EAECF0]">
              <div className="px-6 pt-6 pb-8 w-full">
                <div className="w-full">
                  <div className="flex flex-col w-full">
                    <div className="flex gap-2 items-center self-start whitespace-nowrap">
                      <div className="self-stretch my-auto text-lg font-semibold leading-loose text-gray-900">
                        18,000L
                      </div>
                      <div className="self-stretch px-2 py-0.5 my-auto text-sm font-medium leading-none text-center bg-white rounded-md border border-solid shadow-sm border-[#D0D5DD] text-slate-700">
                        Monthly
                      </div>
                    </div>
                    <div className="mt-1 text-sm leading-none text-slate-600">
                      Our most popular plan for small homes.
                    </div>
                  </div>
                </div>
                <div className="mt-6 w-full">
                  <div className="text-sm font-medium leading-none text-gray-900">
                    14,000L used
                  </div>
                  <div className="flex gap-3 items-center mt-3 w-full">
                    <div className="flex-1 shrink self-stretch my-auto w-full rounded-lg basis-0 min-w-60">
                      <div className="flex flex-col items-start bg-gray-200 rounded-full">
                        <div className="flex shrink-0 h-2 bg-blue-600 rounded-full w-[220px]" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-3 w-full text-sm font-semibold leading-none text-blue-700">
                <div className="flex w-full bg-gray-200 min-h-px" />
                <div className="flex gap-4 items-center px-4 mt-3 w-full">
                  <div className="flex flex-1 shrink gap-3 items-center self-stretch my-auto w-full basis-0 min-w-60">
                    <Link 
                      to="/change-plan" 
                      className="flex overflow-hidden gap-1.5 justify-center items-center self-stretch my-auto hover:text-blue-800 transition-colors"
                      onClick={() => setToast({ type: 'info', message: 'Plan upgrade', description: 'Navigating to plan selection page' })}
                    >
                      <div className="self-stretch my-auto">Upgrade plan</div>
                      <img
                        src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/e05d5c4475e56937f23b27afe58cebfc1cf66166?placeholderIfAbsent=true"
                        className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                        alt="Arrow right"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Toast Notification */}
            {toast && (
              <ToastNotification
                type={toast.type}
                message={toast.message}
                description={toast.description}
                onClose={() => setToast(null)}
              />
            )}
            
            {/* Payment Method */}
            <div className="overflow-hidden mt-5 w-full bg-white rounded-xl border border-solid shadow-sm border-[#EAECF0]">
              <div className="px-4 pt-5 pb-4 w-full">
                <div className="w-full">
                  <div className="text-lg font-semibold leading-loose text-gray-900">
                    Payment method
                  </div>
                  <div className="mt-1 text-sm leading-none text-slate-600">
                    Change how you pay for your plan.
                  </div>
                </div>
                <div className="flex gap-4 items-start p-4 mt-5 w-full text-sm leading-none bg-white rounded-lg border border-gray-200 border-solid">
                  <div className="flex flex-1 shrink gap-2 items-start w-full basis-0 min-w-60">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/864a3ff47ae68cde61fe80adc89953f05458b3c2?placeholderIfAbsent=true"
                      className="object-contain shrink-0 rounded aspect-[1.42] w-[34px]"
                      alt="Visa card"
                    />
                    <div className="flex-1 shrink basis-0">
                      <div className="flex gap-2 items-start w-full">
                        <div className="flex-1 shrink basis-0">
                          <div className="font-medium text-slate-700">
                            Visa ending in 1234
                          </div>
                          <div className="text-slate-600">Expiry 06/2024</div>
                        </div>
                        <div className="flex gap-3 items-start font-semibold whitespace-nowrap text-slate-700">
                          <button 
                            className="flex overflow-hidden gap-1 justify-center items-center px-3.5 py-2.5 bg-white rounded-lg border border-solid shadow-sm border-[#D0D5DD] hover:bg-gray-50 transition-colors"
                            onClick={() => setToast({ type: 'info', message: 'Edit payment method', description: 'Payment method editing will be available soon' })}
                          >
                            <div className="self-stretch px-0.5 my-auto">
                              Edit
                            </div>
                          </button>
                        </div>
                      </div>
                      <div className="flex gap-1.5 items-center mt-2 w-full whitespace-nowrap text-slate-600">
                        <img
                          src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/74f4f8c4ef982ef1fc15e7a755811668611e5ab7?placeholderIfAbsent=true"
                          className="object-contain shrink-0 self-stretch my-auto w-4 aspect-square"
                          alt="Email icon"
                        />
                        <div className="flex-1 shrink self-stretch my-auto basis-0">
                          billing@untitledui.com
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Billing History */}
          <div className="z-0 mt-8 w-full">
            <div className="px-4 w-full font-semibold">
              <div className="w-full">
                <div className="flex flex-col w-full">
                  <div className="flex justify-between items-center w-full">
                    <div className="text-lg leading-loose text-gray-900">
                      Billing history
                    </div>
                    <button 
                      className="flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-800 transition-colors"
                      onClick={() => setToast({ type: 'success', message: 'Invoices downloaded', description: 'All billing history has been exported' })}
                    >
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                      </svg>
                      Download all
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="overflow-hidden mt-6 w-full bg-white border-t border-b border-solid shadow-sm border-b-[#EAECF0] border-t-[#EAECF0] rounded-lg">
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left divide-y divide-gray-200">
                  <thead className="text-xs font-medium text-gray-500 bg-gray-50">
                    <tr className="border-b border-gray-200">
                      <th scope="col" className="px-6 py-3 whitespace-nowrap">
                        <div className="flex items-center">
                          <input type="checkbox" className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                          <span className="ml-3">Invoice</span>
                        </div>
                      </th>
                      <th scope="col" className="px-6 py-3 whitespace-nowrap text-right">Amount</th>
                      <th scope="col" className="px-6 py-3 whitespace-nowrap text-right">Date</th>
                      <th scope="col" className="px-6 py-3 whitespace-nowrap text-right">Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {[
                      { plan: 'Basic Plan', date: 'Dec 1, 2022', status: 'Paid', amount: 'R1200.00' },
                      { plan: 'Basic Plan', date: 'Nov 1, 2022', status: 'Paid', amount: 'R1200.00' },
                      { plan: 'Basic Plan', date: 'Oct 1, 2022', status: 'Paid', amount: 'R1200.00' },
                      { plan: 'Basic Plan', date: 'Sep 1, 2022', status: 'Paid', amount: 'R1200.00' },
                      { plan: 'Basic Plan', date: 'Aug 1, 2022', status: 'Paid', amount: 'R1200.00' },
                      { plan: 'Basic Plan', date: 'Jul 1, 2022', status: 'Paid', amount: 'R850.00' },
                      { plan: 'Basic Plan', date: 'Jun 1, 2022', status: 'Paid', amount: 'R850.00' },
                    ].map((invoice, index) => (
                      <tr 
                        key={index} 
                        className="bg-white hover:bg-gray-50 transition-colors cursor-pointer" 
                        onClick={() => setToast({ type: 'info', message: 'Invoice details', description: `Viewing ${invoice.plan} - ${invoice.date}` })}
                      >
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <input 
                              type="checkbox" 
                              className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                              onClick={(e) => e.stopPropagation()}
                            />
                            <span className="ml-3 font-medium text-gray-900">{invoice.plan} – {invoice.date.split(', ')[0]}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right font-medium text-gray-900">{invoice.amount}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-gray-500">{invoice.date}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-right">
                          <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">{invoice.status}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TabBar />
    </main>
  );
};

export default TopUpDashboard;
